import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import { object, string } from 'yup';

import UpdateUserEmail from 'buyside/graphql/mutations/UpdateUserEmail';

import ChangeUserLogIn from 'buyside/components/presentation/UserAccount/ChangeEmailPassword/changeUserLogIn';

const emailValidationSchema = object().shape({
  email: string()
    .email('Invalid email address')
    .required('Required'),
  password: string().required('Required')
});
const handleError = (e, setErrors) => setErrors({ password: e.graphQLErrors[0].message });

const ChangeEmailContainer = ({ currentUser }) => {
  const { email, password } = currentUser;
  const formFields = [
    { type: 'input', name: 'email', label: 'Enter Your Email', value: email },
    { type: 'password', name: 'password', label: 'Enter Your Password', value: password }
  ];
  return (
    <Mutation mutation={UpdateUserEmail}>
      {mutate => {
        const updateEmail = args => mutate({ variables: args });
        return (
          <ChangeUserLogIn
            buttonText="Update email"
            changeText="Change Email"
            formFields={formFields}
            handleError={handleError}
            handleUpdate={updateEmail}
            label="Your email address"
            successMessage="Email successfully updated"
            userInfo={email}
            validationSchema={emailValidationSchema}
          />
        );
      }}
    </Mutation>
  );
};

export default ChangeEmailContainer;
